<div class="mercer-support-survey-results">
  <h4>
    <mat-icon>support</mat-icon>
    {{ 'mercer-support.dialog.survey-results' | translate }}
  </h4>
  @if (!isLocked()) {
    <div class="survey-information">
      <mat-icon>info_outlined</mat-icon>
      <p>{{ 'mercer-support.dialog.survey-results-description' | translate }}</p>
    </div>
  }
  <form #surveyForm="ngForm">
    <coin-customer-survey
      name="survey"
      [isLocked]="isLocked() || mercerSupportDetailsService.isReadOnly"
      [disabled]="!isSurveyEditable"
      [(ngModel)]="_survey"
      (completeSurvey)="checkForResultAndProcessIt()"></coin-customer-survey>
  </form>

  @if (showCareerInfoNotApplicable()) {
    <p class="career-info-not-applicable bold">
      <mat-icon>info</mat-icon>
      {{ 'mercer-support.dialog.career-info-not-applicable' | translate }}
    </p>
  }

  <customer-position-survey-result
    [isLocked]="isLocked()"
    [memberDetails]="memberDetails()"
    [derivedPositionClass]="derivedPositionClass()"
    [pcInputErrorMessage]="pcInputErrorMessage()"
    [positionClassValidationErrors]="positionClassValidationErrors()"
    [positionClassValidationWarnings]="positionClassValidationWarnings()"
    [isEditable]="arePositionSpecsEditable && !disablePositionClass()"
    [dialogType]="dialogType()"
    [isFinalizationAllowed]="isFinalizationAllowed()"
    [hideSaveButton]="isMassDialog() || isLocked()"
    (finalizePositionClass)="finalizePositionClass.emit()"
    (changePositionClass)="changePositionClass.emit($event)"
    (acceptProposedPositionClass)="acceptProposedPositionClass.emit()"></customer-position-survey-result>
</div>
